import React, { useEffect, useState } from "react";
import Login from "./Login";
import Leads from "./Leads";
import Dashboard from "./Dashboard";
import Signup from "./Signup";
import logo from "./assets/logo.png";
import Profile from "./Profile";
import SubscriptionPage from "./SubscriptionPage";
import PrivacyPolicy from "./PrivacyPolicy";
import VerifyEmail from "./VerifyEmail";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import StaffLogin from "./StaffLogin";
import StaffActivate from "./StaffActivate";
import StaffWorkspace from "./StaffWorkspace";
import StaffAccessSettings from "./StaffAccessSettings";

const CRM_PAGES = ["dashboard", "leads", "profile", "subscription", "staff-access"];

function App() {
  useEffect(() => {
    // Load Facebook JavaScript SDK once
    if (document.getElementById("facebook-jssdk")) {
      return;
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "993811783183825",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v26.0"
      });

      console.log("Facebook SDK initialized");
    };

    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";

    document.body.appendChild(script);
  }, []);

  const isPrivacyPolicy =
    window.location.pathname === "/privacy-policy";

  const isVerifyEmail = window.location.pathname === "/verify-email";
  const isResetPassword = window.location.pathname === "/reset-password";

  const isStaffLogin = window.location.pathname === "/staff-login";
  const isStaffActivate = window.location.pathname === "/staff-activate";
  const isStaffWorkspace = window.location.pathname === "/staff";

  const isMobile = window.innerWidth < 768;

  const [page, setCurrentPage] = useState(() => {
    if (!localStorage.getItem("userId")) return "login";

    const savedPage = window.history.state?.mukbiPage;
    return CRM_PAGES.includes(savedPage) ? savedPage : "dashboard";
  });

  const setPage = (nextPage) => {
    const currentPage = window.history.state?.mukbiPage;
    const resolvedPage =
      typeof nextPage === "function"
        ? nextPage(currentPage || page)
        : nextPage;

    if (
      localStorage.getItem("userId") &&
      CRM_PAGES.includes(resolvedPage) &&
      resolvedPage !== (currentPage || page)
    ) {
      window.history.pushState(
        { ...window.history.state, mukbiPage: resolvedPage },
        "",
        window.location.href
      );
    }

    setCurrentPage(resolvedPage);
  };

  useEffect(() => {
    if (!localStorage.getItem("userId")) return;

    if (!window.history.state?.mukbiPage) {
      window.history.replaceState(
        { ...window.history.state, mukbiPage: "dashboard" },
        "",
        window.location.href
      );
    }

    const handlePopState = (event) => {
      const previousPage = event.state?.mukbiPage;

      if (CRM_PAGES.includes(previousPage)) {
        setCurrentPage(previousPage);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const [globalFilter, setGlobalFilter] = useState(null);

  if (isStaffActivate) {
    return <StaffActivate />;
  }
  if (isStaffLogin) {
    return <StaffLogin />;
  }
  if (isStaffWorkspace) {
    return <StaffWorkspace />;
  }
  if (isPrivacyPolicy) {
    return <PrivacyPolicy />;
  }
  if (isVerifyEmail) {
    return <VerifyEmail setPage={setPage} />;
  }
  if (isResetPassword) {
    return <ResetPassword setPage={setPage} />;
  }
  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    try {
      if (token) {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || "http://localhost:3001"}/logout`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (!response.ok) {
          console.warn(
            "Backend logout returned:",
            response.status
          );
        }
      }
    } catch (err) {
      console.error("Backend logout failed:", err);
    } finally {
      // Always clear the browser session.
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("whatsappConnected");

      setPage("login");
      window.location.reload();
    }
  };
  const headerStyle = {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    justifyContent: "space-between",
    padding: "10px 20px",
    background: "#2c3e50",
    color: "white"
  };
  const navButton = {
    background: "transparent",
    border: "none",
    color: "white",
    cursor: "pointer",
    fontSize: 14
  };




  return (
    <div>
      {/* Header */}




      {/* Navigation */}

      {localStorage.getItem("userId") && (
      <div style={headerStyle}>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap"
          }}
        >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "white",          // 👈 white box
            padding: "6px 12px",
            borderRadius: 8,
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
          }}
        >
          <img
            src={logo}
            alt="Mukbi"
            style={{ height: 40, cursor: "pointer" }}
            onClick={() => setPage("dashboard")}
          />

          <span
            style={{
              fontSize: 16,
              fontWeight: "600",
              color: "#2c3e50"   // 👈 dark text (VERY IMPORTANT)
            }}
          >
            Mukbi CRM
          </span>
        </div>

          <button style={navButton} onClick={() => setPage("dashboard")}>
            Dashboard
          </button>
          <span style={{ color: "#ccc" }}>|</span>

          <button style={navButton} onClick={() => setPage("leads")}>
            Customers
          </button>
          <span style={{ color: "#ccc" }}>|</span>

          <button style={navButton} onClick={() => setPage("profile")}>
            Profile
          </button>
          <span style={{ color: "#ccc" }}>|</span>

          <button style={navButton} onClick={() => setPage("staff-access")}>
            Staff Access
          </button>
          <span style={{ color: "#ccc" }}>|</span>

          <button style={navButton} onClick={() => setPage("subscription")}>
            Subscription
          </button>

        </div>

        <div style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
            marginBottom: 15
            }}
        >
          {/* LEFT */}
          <div style={{
            fontSize: 16,
            fontWeight: "600",
            color: "white",
            marginRight: 10
            }}>
            Welcome {localStorage.getItem("userName")}
          </div>
          <span style={{ color: "#ccc" }}>|</span>

          {/* RIGHT */}
          <div
            onClick={handleLogout}
            style={{
              fontSize: 12,
              marginLeft: 15,
              color: "#9ca3af",
              cursor: "pointer"
            }}
            onMouseOver={(e) => e.target.style.color = "Red"}
            onMouseOut={(e) => e.target.style.color = "#9ca3af"}
          >
            Logout
          </div>
        </div>

      </div>
      )}

      {/* Pages */}
      <div style={{ padding: "0 20px" }}>
      {page === "signup" && <Signup setPage={setPage} />}
      {page === "login" && <Login setPage={setPage} />}
      {page === "forgot-password" && <ForgotPassword setPage={setPage} />}
      {page === "dashboard" && (
        <Dashboard
        setPage={setPage}
        setGlobalFilter={setGlobalFilter}
        handleLogout={handleLogout}
        />
      )}
      {page === "leads" && (
        <Leads
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setPage={setPage}
        />
      )}
      {page === "subscription" && localStorage.getItem("userId") && (
        <SubscriptionPage />
      )}
      {page === "staff-access" && localStorage.getItem("userId") && (
        <StaffAccessSettings />
      )}
      {page === "profile" && localStorage.getItem("userId") && (
        <Profile />
      )}
      </div>
      <div
        style={{
          marginTop: 30,
          padding: 10,
          textAlign: "center",
          fontSize: 12,
          color: "Black",
          borderTop: "1px solid #eee"
        }}
      >
        Powered by <b>Mukbi</b>
        {" | "}
        <a
          href="/privacy-policy"
          style={{
            color: "#2c3e50",
            textDecoration: "none"
          }}
        >
          Privacy Policy
        </a>
        {" | "}
        support: +91 - 97787 97784
      </div>
    </div>

  );
}

export default App;